import MdaeFileUploader from "./component";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
import { IFileUploaderOptions } from "devextreme-react/file-uploader";
export interface IMdaeFileUploaderProps extends IFileUploaderOptions {
  id: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  showUploadButton?: boolean
}
export default MdaeFileUploader;
